const redirectToCheckout = (session, location = window.location) => {
  if (typeof session?.url !== "string" || !session.url.trim()) {
    throw new Error(
      "The payment API must return the Stripe Checkout Session url; a session id alone is not sufficient.",
    );
  }

  location.assign(session.url);
};

export default redirectToCheckout;